
import React, { useState } from 'react';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';
import { Button, Col, Container, FormControl, InputGroup, Row } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';

import { login } from '../db/User';
import { httpPost } from '../services/http';

const DEFAULT_STATE = {
  error: false,
  username: '',
  password: '',
  redirect: false,
}


const Login = (props) => {
  const { route, login } = props
  const [state, setState] = useState(DEFAULT_STATE)
  const { redirect, username, password, error } = state

  const updateState = (value, key) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }))
  }

  const onChange = (type) => (e) => {
    updateState(e.target.value, type)
  };

  const onSubmit = () => {
    httpPost('users/login', state)
      .then((res) => {
        if (res.error) {
          setState(prevState => ({
            ...prevState,
            error: true
          }))
        } else {
          login(state);
          setState(prevState => ({
            ...prevState,
            redirect: true
          }))
        }
      })
  }

  const click = (event) => {
    const { target: { className = {} } = {} } = event || {}
    const shouldRedirect = ['loginContainer', 'form-control', 'h5'].every((item) => className.search(item) < 0)
    if (shouldRedirect) {
      setState(prevState => ({
        ...prevState,
        redirect: true
      }))
    }
  }

  if (redirect) {
    return (
      <Redirect to={route} />
    )
  }

  return (
    <div className='loginWrapper' onClick={click}>
      <Container fluid>
        <Row
          className='justify-content-center'
          style={{
            alignContent: 'center',
            display: 'flex',
            height: '100vh'
          }}
        >
          <Col className='loginContainer'>
            <h5 className='h5'>Вход в личный кабинет</h5>
            <br />
            <InputGroup className='mb-3'>
              <FormControl
                placeholder='Логин'
                aria-label='Логин'
                value={username}
                onChange={onChange('username')}
              />
            </InputGroup>
            <InputGroup className='mb-3'>
              <FormControl
                placeholder='Пароль'
                aria-label='Пароль'
                type='password'
                value={password}
                onChange={onChange('password')}
              />
            </InputGroup>
            {error && (
              <div className='error' style={{ color: 'red' }}>
                {'Логин, или пароль неправильный'}
              </div>
            )}
            <Button
              className='h5'
              style={{ width: '100%' }}
              onClick={onSubmit}
            >
              Войти
            </Button>
            <Link
              to={`${route}#register`}
              className='formLink'
            >
              Зарегистрироваться
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

function mapStateToProps() {
  return {}
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ login }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Login)